import classNames from "classnames";
import React from "react";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  type?: "text" | "spinner";
  className?: string;
}

function LoadingIcon({ type = "text", className }: IProps) {
  return (
    <div className={classNames("flex flex-1 flex-col items-center justify-center", className)}>
      {type === "text" && <Icon height="30px" name={IconName.Loading} width="160px" />}
      {type === "spinner" && <Icon height="20px" name={IconName.Spinner} width="20px" />}
    </div>
  );
}

export default LoadingIcon;
